<div class="blacklist-administration">

    <div class="top-toolbar">
        <sc-cancel-button type="button" (click)="cancel()" [disabled]="loading || !dirty"></sc-cancel-button>
        <div class="spaced"></div>

        <sc-save-button primary type="button" (click)="save()" [disabled]="loading || !dirty || !valid"></sc-save-button>
    </div>

    <app-service-response [responseMessages]="responseMessages"></app-service-response>

    <div class="table-container">

        <table mat-table [dataSource]="dataSource" class="table">

            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef>
                    <sc-dictionary-label dictionaryKey="tmc-common.blacklist.entity.company"></sc-dictionary-label>
                </th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <ng-container *ngIf="!this.selection.isSelected(blacklist)">
                        {{blacklist.company}}
                    </ng-container>
                    <ng-container *ngIf="this.selection.isSelected(blacklist)">
                        <mat-form-field class="" appearance="fill">
                            <input matInput [(ngModel)]="blacklist.company"
                                (ngModelChange)="blacklistDetailsChanged(blacklist)">
                        </mat-form-field>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                    <sc-dictionary-label dictionaryKey="tmc-common.blacklist.entity.name"></sc-dictionary-label>
                </th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <ng-container *ngIf="!this.selection.isSelected(blacklist)">
                        {{blacklist.name}}
                    </ng-container>
                    <ng-container *ngIf="this.selection.isSelected(blacklist)">
                        <mat-form-field class="" appearance="fill">
                            <input matInput [(ngModel)]="blacklist.name"
                                (ngModelChange)="blacklistDetailsChanged(blacklist)">
                        </mat-form-field>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="firstname">
                <th mat-header-cell *matHeaderCellDef>
                    <sc-dictionary-label dictionaryKey="tmc-common.blacklist.entity.firstname"></sc-dictionary-label>
                </th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <ng-container *ngIf="!this.selection.isSelected(blacklist)">
                        {{blacklist.firstname}}
                    </ng-container>
                    <ng-container *ngIf="this.selection.isSelected(blacklist)">
                        <mat-form-field class="" appearance="fill">
                            <input matInput [(ngModel)]="blacklist.firstname"
                                (ngModelChange)="blacklistDetailsChanged(blacklist)">
                        </mat-form-field>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="numberPlate">
                <th mat-header-cell *matHeaderCellDef>
                    <sc-dictionary-label dictionaryKey="tmc-common.blacklist.entity.number-plate"></sc-dictionary-label>
                </th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <ng-container *ngIf="!this.selection.isSelected(blacklist)">
                        {{blacklist.numberPlate}}
                    </ng-container>
                    <ng-container *ngIf="this.selection.isSelected(blacklist)">
                        <mat-form-field class="" appearance="fill">
                            <input matInput [(ngModel)]="blacklist.numberPlate"
                                (ngModelChange)="blacklistDetailsChanged(blacklist)">
                        </mat-form-field>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="note">
                <th mat-header-cell *matHeaderCellDef>
                  <sc-dictionary-label dictionaryKey="tmc-common.blacklist.entity.note"></sc-dictionary-label>
                </th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <ng-container *ngIf="!this.selection.isSelected(blacklist)">
                        {{blacklist.note}}
                    </ng-container>
                    <ng-container *ngIf="this.selection.isSelected(blacklist)">
                        <mat-form-field class="" appearance="fill">
                            <input matInput [(ngModel)]="blacklist.note"
                                (ngModelChange)="blacklistDetailsChanged(blacklist)">
                        </mat-form-field>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="btn">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <div *ngIf="this.selection.isSelected(blacklist)" (click)="delete(blacklist)">
                        <sc-icon iconClass="fa-trash"></sc-icon>
                    </div>
                    <div class="invalid-marker" *ngIf="!this.selection.isSelected(blacklist) && !blacklist.valid">

                    </div>
                </td>
            </ng-container>

            <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->
            <ng-container matColumnDef="noRecord">
                <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
                  <sc-dictionary-label dictionaryKey="shared.tmc-table.nodata"></sc-dictionary-label>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

            <tr mat-row *matRowDef="let blacklist; columns: columnsToDisplay" [attr.data-blacklist-id]="blacklist.id"
                [ngClass]="blacklist.selected ? 'row-selected': 'row-deselected'" (click)="toggleSelection(blacklist)">
            </tr>

            <tr [class.hide]="this.dataSource.filteredData.length !== 0" mat-footer-row *matFooterRowDef="['noRecord']">
            </tr>
        </table>
    </div>

    <div class="bottom-toolbar">
        <button mat-flat-button type="button" (click)="addDetails()" [disabled]="loading">
            <sc-icon iconClass="fa-plus"></sc-icon>
        </button>
    </div>
</div>
